<button 
    mat-fab 
    color="primary" 
    (click)="onScrollTop()"
    ngbTooltip="Go to top"
    placement="bottom">
    <div class="scroll-icon">
        <span class="material-symbols-outlined">keyboard_arrow_up</span>
    </div>
</button>
